/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowProductPrintOptionPriceScalesQueryResponse, GetShowProductPrintOptionPriceScalesPathParams, GetShowProductPrintOptionPriceScalesQueryParams, GetShowProductPrintOptionPriceScales401, GetShowProductPrintOptionPriceScales403, GetShowProductPrintOptionPriceScales404 } from "../../models/GetShowProductPrintOptionPriceScales";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowProductPrintOptionPriceScalesUrl({ code }: { code: GetShowProductPrintOptionPriceScalesPathParams["code"] }) {
  const res = { method: 'GET', url: `/api/v1/products/${code}/print-option-price-scales` as const }  
  return res
}

/**
 * {@link /api/v1/products/:code/print-option-price-scales}
 */
export async function getShowProductPrintOptionPriceScales({ code, params }: { code: GetShowProductPrintOptionPriceScalesPathParams["code"]; params: GetShowProductPrintOptionPriceScalesQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowProductPrintOptionPriceScalesQueryResponse, ResponseErrorConfig<GetShowProductPrintOptionPriceScales401 | GetShowProductPrintOptionPriceScales403 | GetShowProductPrintOptionPriceScales404>, unknown>({ method : "GET", url : getGetShowProductPrintOptionPriceScalesUrl({ code }).url.toString(), params, ... requestConfig })  
  return res.data
}